import { useLocation } from 'react-router';

export const useQuery = () => new URLSearchParams(useLocation().search);

export const useQueryParam = (param: string) => {
  const query = new URLSearchParams(useLocation().search);
  if (!query) return undefined;
  return query.get(param) || undefined;
};
